import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'
import { InventoryBySerialNumber } from '../InventoryBySerialNumber'

@InputType()
export class AddMultipleSerialNumbersArgs extends ActionArgs {
  @Field(() => ID)
  productId: string

  @Field(() => [InventoryBySerialNumber])
  inventoryBySerialNumbers: InventoryBySerialNumber[]
}

export interface IAddMultipleSerialNumbers extends IAction<InventoryBySerialNumber[], AddMultipleSerialNumbersArgs> {}
